import { useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { SelectBox } from "@/components/Inputs";
import { GradButton, fmtMoney } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const SECENEK = {
  giris: [["tahsilat", "Cari tahsilatı olarak düş"], ["cek_tahsil", "Bankaya verilen çek / senet tahsil edildi"], ["kayitli", "Sistemde zaten kayıtlı"], ["manuel", "Diğer gelir (hesap hareketi)"], ["yoksay", "Yoksay"]],
  cikis: [["odeme", "Tedarikçi ödemesi olarak düş"], ["kayitli", "Sistemde zaten kayıtlı"], ["manuel", "Masraf / diğer (hesap hareketi)"], ["yoksay", "Yoksay"]],
};

const Detay = ({ secim, x, f, set, cariler, cekler }) => {
  const o = x.oneri || {};
  if (secim === "tahsilat" || secim === "odeme") {
    const tip = secim === "tahsilat" ? "tedarikci" : "musteri";
    return <div className="w-72"><SelectBox testid={`akis-cari-${x.id}`} placeholder={secim === "tahsilat" ? "Müşteri seç" : "Tedarikçi seç"} value={f.cari_id} onChange={(v) => set("cari_id", v)}
      options={cariler.filter((c) => c.tip !== tip).map((c) => ({ value: c.id, label: c.unvan }))} /></div>;
  }
  if (secim === "cek_tahsil") {
    return <div className="w-80"><SelectBox testid={`akis-cek-${x.id}`} placeholder="Portföydeki çek / senet" value={f.tahsilat_id} onChange={(v) => set("tahsilat_id", v)}
      options={cekler.map((c) => ({ value: c.id, label: `${c.no} · ${c.cari_unvan} · ${fmtMoney(c.tutar, c.para_birimi)} · vade ${c.vade_tarihi}` }))} /></div>;
  }
  if (secim === "kayitli") {
    return o.kayitli?.length ? <div className="w-80"><SelectBox testid={`akis-kayitli-${x.id}`} placeholder="Eşleşen kayıt" value={f.belge} onChange={(v) => set("belge", v)}
      options={o.kayitli.map((h) => ({ value: h.belge, label: `${h.tarih} · ${h.belge} · ${h.aciklama}` }))} /></div>
      : <Input data-testid={`akis-belge-${x.id}`} placeholder="Belge no (ör. THS-00012)" className="bg-white/5 w-60" value={f.belge || ""} onChange={(e) => set("belge", e.target.value)} />;
  }
  if (secim === "manuel") return <Input data-testid={`akis-aciklama-${x.id}`} placeholder="Açıklama" className="bg-white/5 w-72" value={f.aciklama} onChange={(e) => set("aciklama", e.target.value)} />;
  return null;
};

export const AkisSatir = ({ x, cariler, cekler, onDone }) => {
  const o = x.oneri || {};
  const [secim, setSecim] = useState(o.varsayilan || "");
  const [f, setF] = useState({ cari_id: o.cari?.id || "", tahsilat_id: o.cek?.id || "", belge: o.kayitli?.[0]?.belge || "", aciklama: x.aciklama });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const uygula = async () => {
    setBusy(true);
    try { await api.post(`/finekra/hareketler/${x.id}/isle`, { islem: secim, ...f }); toast.success("Banka hareketi işlendi"); onDone(); } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="border-t border-white/5 p-4" data-testid={`akis-satir-${x.finekra_id}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0"><div className="text-sm">{x.aciklama}</div>
          <div className="text-xs text-muted-foreground">{x.tarih} · {x.hesap_ad}{x.karsi_unvan ? ` · ${x.karsi_unvan}` : ""}{x.mod === "test" && <span className="ml-1 text-amber-300">TEST</span>}</div></div>
        <div className={`font-mono text-lg ${x.tutar < 0 ? "text-red-300" : "text-emerald-300"}`} data-testid={`akis-tutar-${x.finekra_id}`}>{fmtMoney(x.tutar, x.para_birimi)}</div>
      </div>
      <div className="mt-3 rounded-xl bg-white/[0.03] p-3">
        <div className="text-[11px] uppercase tracking-[0.15em] text-muted-foreground mb-2">{x.yon === "giris" ? "Bu para carilerden nasıl düşülsün?" : "Bu çıkış nasıl kaydedilsin?"}
          {o.cari && <span className="ml-2 normal-case tracking-normal text-[var(--g1)]">öneri: {o.cari.unvan}</span>}{o.cek && <span className="ml-2 normal-case tracking-normal text-[var(--g1)]">öneri: çek {o.cek.no}</span>}</div>
        <div className="flex flex-wrap gap-2 mb-3">{SECENEK[x.yon].map(([k, l]) => (
          <button key={k} data-testid={`akis-secim-${k}-${x.id}`} onClick={() => setSecim(k)} className={`px-3 py-1.5 rounded-full text-xs border ${secim === k ? "border-[var(--g1)] bg-white/10 text-white" : "border-white/10 text-muted-foreground hover:text-white"}`}>{l}</button>
        ))}</div>
        {secim && <div className="flex flex-wrap items-center gap-2"><Detay secim={secim} x={x} f={f} set={set} cariler={cariler} cekler={cekler} />
          <GradButton onClick={uygula} disabled={busy} data-testid={`akis-uygula-${x.id}`}><Check className="w-4 h-4" />Uygula</GradButton></div>}
      </div>
    </div>
  );
};
